import React from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../i18n";
import { Coins, Route, Compass, CloudSun, MessageSquareText, ArrowUpRight } from "lucide-react";
import SEO, { buildBreadcrumb } from "../components/SEO";

const TOOL_ICONS = {
  currency: Coins, distance: Route, budget: Compass, weather: CloudSun, phrasebook: MessageSquareText,
};

export default function ToolsIndex() {
  const { locale, t } = useLocale();
  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-24" data-testid="tools-index-page">
      <SEO
        title={locale === "ro" ? "Utilitare de călătorie pentru România" : "Travel utility tools for Romania"}
        description={locale === "ro"
          ? "5 utilitare care chiar funcționează: curs valutar RON, distanțe, buget, meteo și un phrasebook românesc."
          : "5 utilities that actually work: RON currency converter, distances, budget, weather and a Romanian phrasebook."}
        path="/tools"
        jsonLd={[buildBreadcrumb([
          { name: locale === "ro" ? "Acasă" : "Home", path: "/" },
          { name: "Tools", path: "/tools" },
        ])]}
      />
      <p className="font-mono-wr text-[11px] uppercase tracking-[0.3em] text-[var(--wr-red)] mb-4">
        / {locale === "ro" ? "TOOLS" : "TOOLS"} · 05
      </p>
      <h1 className="font-editorial text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight text-[var(--wr-ink)] mb-6">
        {t("tools.heading")}
      </h1>
      <p className="text-[17px] leading-relaxed text-[var(--wr-ink-2)] max-w-xl mb-16">
        {t("tools.sub")}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {["currency", "distance", "budget", "weather", "phrasebook"].map((slug, i) => {
          const Icon = TOOL_ICONS[slug];
          return (
            <Link
              key={slug}
              to={`/tools/${slug}`}
              data-testid={`tools-idx-${slug}`}
              className="wr-sharp-card p-8 group flex flex-col justify-between min-h-[260px] hover:-translate-y-1"
            >
              <div className="flex items-start justify-between">
                <Icon size={28} className="text-[var(--wr-red)]" />
                <span className="font-mono-wr text-[10px] uppercase tracking-widest text-[var(--wr-ink-2)]">/ 0{i + 1}</span>
              </div>
              <div>
                <h3 className="font-editorial text-4xl leading-none tracking-tight text-[var(--wr-ink)] mb-3">
                  {t(`tools.${slug}`)}
                </h3>
                <p className="text-[14px] text-[var(--wr-ink-2)] leading-snug">{t(`tools.${slug}_sub`)}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-[11px] font-mono-wr uppercase tracking-widest text-[var(--wr-ink)] group-hover:text-[var(--wr-red)]">
                  {t("tools.open")} <ArrowUpRight size={14} />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
